// extracted by mini-css-extract-plugin
export default {"consent":"CookieModal_consent__LRfpO","consentGrid":"CookieModal_consentGrid__vN9O6","buttonGrid":"CookieModal_buttonGrid__GkiCX","consentModal":"CookieModal_consentModal__bYXMy"};